import { Link } from 'react-router'

const GROUPS: { title: string; links: { to: string; label: string }[] }[] = [
  {
    title: 'Platform',
    links: [
      { to: '/platform', label: 'Platform overview' },
      { to: '/platform#capability-systems', label: 'Capability systems' },
      { to: '/platform#extensibility', label: 'Extensibility and APIs' },
      { to: '/nex', label: 'Nex' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { to: '/solutions#insurance', label: 'Insurance' },
      { to: '/solutions#contact-centers', label: 'Contact centers' },
      { to: '/solutions#sales-acquisition', label: 'Sales and acquisition' },
      { to: '/solutions#in-person-sales', label: 'In-person sales' },
    ],
  },
  {
    title: 'Developers',
    links: [
      { to: '/integrations', label: 'Integration catalog' },
      { to: '/platform#extensibility', label: 'Events, webhooks, and relays' },
      { to: '/security#audit', label: 'Audit and operational logs' },
    ],
  },
  {
    title: 'Trust',
    links: [
      { to: '/security', label: 'Security overview' },
      { to: '/security#access', label: 'Access and sessions' },
      { to: '/security#audit', label: 'Evidence and logs' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy' },
      { to: '/terms', label: 'Terms' },
    ],
  },
]

export function SiteFooter() {
  return (
    <footer className="border-t border-base-line bg-base-950">
      <div className="mx-auto w-full max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_repeat(5,1fr)]">
          <div>
            <p className="flex items-center gap-2.5">
              <img
                src="/images/tldnxs-blue-wht-logo.png"
                alt=""
                width={24}
                height={28}
                className="h-6 w-auto"
                loading="lazy"
              />
              <span className="font-display text-sm font-semibold tracking-[0.1em] text-ink">
                TLDNXS
              </span>
            </p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-ink-dim">
              by Esotech
            </p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink-mute">
              The Customer Operations Platform. One configurable operating model for customer
              records, communications, routing, workflows, workforce state, documents, and
              outcomes.
            </p>
            <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.2em] text-ink-dim/70">
              Total Lead Domination.
            </p>
          </div>
          {GROUPS.map((group) => (
            <nav key={group.title} aria-label={`Footer: ${group.title}`}>
              <p className="mono-label">{group.title}</p>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-ink-mute transition-colors duration-micro hover:text-signal"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 border-t border-base-line pt-8">
          <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-ink-mute">
            CRMs store contacts. TLDNXS runs the work.
          </p>
          <div className="mt-5 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div className="max-w-xl">
              <p className="text-xs leading-relaxed text-ink-dim">
                This site targets WCAG 2.2 AA: semantic structure, keyboard paths, visible focus,
                and reduced-motion support.
              </p>
              <p className="mt-3 text-xs text-ink-dim">
                TLDNXS is a product of Esotech.{' '}
                <Link
                  to="/privacy"
                  className="underline decoration-base-linebright underline-offset-2 transition-colors duration-micro hover:text-signal"
                >
                  Privacy
                </Link>{' '}
                <Link
                  to="/terms"
                  className="underline decoration-base-linebright underline-offset-2 transition-colors duration-micro hover:text-signal"
                >
                  Terms
                </Link>
              </p>
            </div>
            <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-signal/80">
              Customer Operations Platform
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
